export const selectHasUnsavedChanges = (state) =>
  state.photos.some((p) => p.currentVersion !== p.savedVersion);

export const selectSizesWithPhotos = (allSizes = [], photos = []) => {
  const sizeMap = new Map();

  // Initialize map with sizes
  allSizes.forEach((size) => {
    sizeMap.set(size.key, { ...size, photos: [] });
  });

  // Attach photos to their respective sizes
  photos.forEach((photo) => {
    const shouldInclude = photo.quantity > 0 || photo.keepInUiWhenZeroQuantity;

    if (shouldInclude && sizeMap.has(photo.sizeKey)) {
      sizeMap.get(photo.sizeKey).photos.push(photo);
    }
  });

  return Array.from(sizeMap.values());
};

export const selectSizesByFinish = (sizesWithPhotos, selectedFinishName) => {
  if (!selectedFinishName) return [];

  const regex = new RegExp(`${selectedFinishName}`);
  return sizesWithPhotos.filter((size) => size.key.match(regex));
};

export const selectHasPrints = (photos) => {
  return photos.some((photo) => photo.quantity > 0);
};

export const selectTotalQuantity = (photos = []) => {
  return photos.reduce((total, photo) => total + photo.quantity, 0);
};

export const selectAvailableSizesForDeliveryAndFinish = (
  allSizes,
  deliveryOptionKey,
  finishName,
) => {
  if (!allSizes || !deliveryOptionKey || !finishName) {
    return [];
  }

  return allSizes.filter(
    (size) =>
      size.options.finish.name === finishName &&
      (size.options.delivery_options || []).includes(deliveryOptionKey),
  );
};
